<div class="modals">
  <div class="modal-content">
    <div class="modal-header py-4 d-block">
      <h5 class="text-center">{{ 'MODALS_ADD_CHARITY_TITLE' | translate }}</h5>
    </div>
    <div class="modal-body">
      <p>{{ 'NEW_CHARITY_MAIN_TEXT' | translate }}</p>
      <p *ngIf="hasSecondaryText">{{ 'NEW_CHARITY_SECONDARY_TEXT' | translate }}</p>

      <p>{{ 'NEW_CHARITY_SIGNATURE' | translate }}</p>

      <p class="small" *ngIf="hasFootNote">{{ 'NEW_CHARITY_FOOT_NOTE' | translate }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="lg-button" (click)="close()">{{ 'GENERAL_OK' | translate | uppercase }}</button>
    </div>
  </div>
</div>
